import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const cdImageUpdateWorkflowPlugin = createPlugin({
  id: 'cd-image-update-workflow',
  routes: {
    root: rootRouteRef,
  },
});

export const CdImageUpdateWorkflowPage = cdImageUpdateWorkflowPlugin.provide(
  createRoutableExtension({
    name: 'CdImageUpdateWorkflowPage',
    component: () =>
      import('./components/WorkflowCard').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const PickShaPage = cdImageUpdateWorkflowPlugin.provide(
  createRoutableExtension({
    name: 'PickShaPage',
    component: () =>
      import('./components/pick-sha').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const PreviewPage = cdImageUpdateWorkflowPlugin.provide(
  createRoutableExtension({
    name: 'PickShaPage',
    component: () =>
      import('./components/PreviewPage').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const ServiceShaPage = cdImageUpdateWorkflowPlugin.provide(
  createRoutableExtension({
    name: 'PickShaPage',
    component: () =>
      import('./components/ServiceShaPage').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);

export const UpdateServicePage = cdImageUpdateWorkflowPlugin.provide(
  createRoutableExtension({
    name: 'PickShaPage',
    component: () =>
      import('./components/update-service').then(module => module.default),
    mountPoint: rootRouteRef,
  }),
);
